import { render } from "./CompanyInfo.vue?vue&type=template&id=1583e652&scoped=true&ts=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts"

import "./CompanyInfo.vue?vue&type=style&index=0&id=1583e652&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1583e652"]])

export default __exports__